import { render, staticRenderFns } from "./AdminIcon.vue?vue&type=template&id=72f109e4&"
import script from "./AdminIcon.vue?vue&type=script&lang=js&"
export * from "./AdminIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports